/*
 *
 * RecordProcesses constants
 *
 */

export const GET_PROCESS_HISTORY_WATCHER =
  "app/Support/RecordProcesses/GET_PROCESS_HISTORY_WATCHER"
export const GET_PROCESS_HISTORY_SUCCESS =
  "app/Support/RecordProcesses/GET_PROCESS_HISTORY_SUCCESS"
export const GET_PROCESS_HISTORY_FAILED =
  "app/Support/RecordProcesses/GET_PROCESS_HISTORY_FAILED"
